import angular from "angular";
import contract from "../../Contract";
import { vsModuleName as configModuleName } from "./configs/module";
import { vsModuleName as sharedModuleName } from "../shared";
import { vsModuleName as contractModuleName } from "../cachecreek/contracts/module";
import {
  MachinesComponentsViewsMain,
  vsComponentName as MachinesComponentsViewsMainName,
} from "./components/views/main/component";
import { routeConfig } from "./routes";
import {
  CloneAndConversionService,
  vsServiceName as CloneAndConversionServiceName,
} from "./services/cloneAndConversionService";
import {
  MachineConfigurationViewDetailComponentOptions,
  vsComponentName as MachineConfigurationViewComponentName,
} from "./components/machineConfigurationDetailView/component";
import {
  machinesMoveViewComponentOptions,
  vsComponentName as machinesMoveViewComponentName,
} from "./components/views/main/move";
import {
  machinesWarehouseMoveViewComponentOptions,
  vsComponentName as machinesWarehouseMoveViewComponentName,
} from "./components/views/main/warehouse";
import {
  machinesDecommissionMoveViewComponentOptions,
  vsComponentName as machinesDecommissionMoveViewComponentName,
} from "./components/views/main/decommission";
import {
  singleMachineMoveComponentOptions,
  vsComponentName as singleMachineMoveComponentName,
} from "./components/views/detail/move/component";
import {
  singleMachineWarehouseComponentOptions,
  vsComponentName as singleMachineWarehouseComponentName,
} from "./components/views/detail/warehouse";
import {
  singleMachineDecommissionComponentOptions,
  vsComponentName as singleMachineDecommissionComponentName,
} from "./components/views/detail/decommission";
import {
  SlotTrakServerAdapter,
  vsName as SlotTrakServerAdapterName,
} from "./slotTrakServerAdapter";
import {
  vsComponentName as machineDetailSpecificComponentName,
  machineDetailSpecificComponentOptions,
} from "./components/views/detail";
import { vsModuleName as partsMachinesModuleName } from "../../parts.machines/module";
import {
  MachineConfigurationTypeDetailViewComponentOptions,
  vsComponentName as MachineConfigurationTypeDetailViewComponentName,
} from "./components/machineConfigurationTypeDetailView";
import {
  machineConfigurationTypeInfoComponentOptions,
  vsComponentName as machineConfigurationTypeInfoComponentName,
} from "./components/views/configurationType/info";

import { vsModuleName as ProgressivesModuleName } from "../../machines.progressives";
import { registerProgressiveComponents } from "../../machines.progressives.components";

import { vsName as DepreciationModuleName } from "../../Depreciation";
import { vsModuleName as mealLogModuleName } from "./mealLog";
import { configMealLogMachineTab } from "../../machines.mealLog/components/entryList/configMealLogMachineTab";

import { vsModuleName as machineConfigurationTypeSubmitOptionsModalServiceModule } from "./services/machineConfigurationTypeSubmitOptionsModalService";

import { vsName as ProjectCostModuleName } from "../../Projects";

import { vsModuleName as processModuleName } from "./processes/module";
//import { default as applicationModuleName } from "../../application";

export const vsModuleName = "SlotTrak.Machines";
export const vsClientName = "cachecreek";
export default vsModuleName;

angular
  .module(vsModuleName, [
    configModuleName,
    sharedModuleName,
    partsMachinesModuleName,
    ProgressivesModuleName,
    contract,
    contractModuleName,
    registerProgressiveComponents(),
    DepreciationModuleName,
    mealLogModuleName,
    machineConfigurationTypeSubmitOptionsModalServiceModule,
    ProjectCostModuleName,
    processModuleName,
  ])
  .constant("clientName", vsClientName)
  .config(routeConfig)
  .config(configMealLogMachineTab)
  .component(MachinesComponentsViewsMainName, MachinesComponentsViewsMain)
  .component(
    MachineConfigurationViewComponentName,
    MachineConfigurationViewDetailComponentOptions,
  )
  .service(CloneAndConversionServiceName, CloneAndConversionService)
  .component(machinesMoveViewComponentName, machinesMoveViewComponentOptions)
  .component(
    machinesWarehouseMoveViewComponentName,
    machinesWarehouseMoveViewComponentOptions,
  )
  .component(
    machinesDecommissionMoveViewComponentName,
    machinesDecommissionMoveViewComponentOptions,
  )
  .component(singleMachineMoveComponentName, singleMachineMoveComponentOptions)
  .component(
    singleMachineWarehouseComponentName,
    singleMachineWarehouseComponentOptions,
  )
  .component(
    singleMachineDecommissionComponentName,
    singleMachineDecommissionComponentOptions,
  )
  .component(
    machineDetailSpecificComponentName,
    machineDetailSpecificComponentOptions,
  )
  .component(
    MachineConfigurationTypeDetailViewComponentName,
    MachineConfigurationTypeDetailViewComponentOptions,
  )
  .component(
    machineConfigurationTypeInfoComponentName,
    machineConfigurationTypeInfoComponentOptions,
  )
  .service(SlotTrakServerAdapterName, SlotTrakServerAdapter);
